import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';

export function configureDayJs() {
  dayjs.extend(utc);
  dayjs.extend(localizedFormat);
}

